/**
 * Countries routed to Sedgwick for IPL claims. All other supported IPL
 * countries route to Zurich.
 *
 * Source of truth: the IPL pre-screen requirements (R5 AC3) which list
 * the nine Sedgwick countries by name. The IPL country list in
 * `src/forms/IPL/options.ts` (`TACT_COUNTRIES`) uses the same human-readable
 * country names as both the option label and the option value, so this
 * regex matches against either form.
 */
const SEDGWICK_IPL_COUNTRIES =
  /^(Austria|Belgium|Canada|France|Germany|Italy|Spain|Sweden|United Kingdom)$/;

/**
 * Routes an IPL incident country to its TPA.
 *
 * Returns `"Sedgwick"` for the nine Sedgwick countries and `"Zurich"` for
 * every other country. The result is used to build the IPL schema name
 * (`IPL-Sedgwick-v1_0_0` or `IPL-Zurich-v1_0_0`).
 *
 * @param country - Country name as stored in the IPL country list (matches
 *                  both `label` and `value` in `TACT_COUNTRIES`).
 */
export function resolveIplTpa(country: string): "Sedgwick" | "Zurich" {
  return SEDGWICK_IPL_COUNTRIES.test(country) ? "Sedgwick" : "Zurich";
}
